module.exports = __webpack_public_path__ + "static/media/car.5a39626f.png";